import { render } from "./LandingPageView.vue?vue&type=template&id=12436540&scoped=true"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"

import "./LandingPageView.vue?vue&type=style&index=0&id=12436540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12436540"]])

export default __exports__